import React from 'react';
export function ServicesHero() {
  return <section className="py-20 md:py-32 bg-cover bg-center bg-no-repeat relative" style={{
    backgroundImage: "url('https://cdn.magicpatterns.com/uploads/qhvwJz6xL2C3TV3K6fSivN/MobileAppDevelopment.png')"
  }} data-id="element-588">
      <div className="absolute inset-0 bg-gradient-to-b from-header/40 via-primary/30 to-primary/50" data-id="element-589"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-590">
        <div className="text-center" data-id="element-591">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 load-fade-in-up stagger-1" data-id="element-592">
            Software Development Services
          </h1>
          <p className="text-xl text-blue-200 leading-relaxed load-fade-in-up stagger-2" data-id="element-593">
            Magnus Software delivers custom software solutions across web,
            mobile, and enterprise platforms. Our engineering team builds
            scalable, maintainable systems designed for your specific business
            requirements.
          </p>
        </div>
      </div>
    </section>;
}